import React from 'react';
import { useHistory } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  EMAIL_TEMPLATE,
  SMS_TEMPLATE,
  TOOLTIP_TEMPLATE,
  AGREEMENT_TEMPLATE,
  TYPESENSE_SEARCH_TEMPLATE,
  SOCKET_IO_TEMPLATE,
  pluginCode,
} from 'drapcode-constant';

export const TemplateHeaderNav = ({ activeTab, title, icon, toggle, installedPlugins }) => {
  const history = useHistory();
  return (
    <nav className="navbar navbar-expand-lg bg-primary">
      <div className="container">
        <div className="navbar-translate">
          <div className="navbar-brand">
            <i className={`wb ${drapcodeIcon(icon ? icon : activeTab)}`} size={'md'}></i>&nbsp;
            <span>{title}</span>
          </div>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className={`nav-item ${activeTab === EMAIL_TEMPLATE && 'active'}`}>
              <div
                className="nav-link"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  toggle(EMAIL_TEMPLATE);
                }}
              >
                <i className={`wb ${drapcodeIcon(EMAIL_TEMPLATE)}`} size={'md'}></i>&nbsp; Email
                Templates
              </div>
            </li>
            <li className={`nav-item ${activeTab === SMS_TEMPLATE && 'active'}`}>
              <div
                className="nav-link"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  toggle(SMS_TEMPLATE);
                }}
              >
                <i className={`wb ${drapcodeIcon(SMS_TEMPLATE)}`} size={'md'}></i>&nbsp; SMS
                Templates
              </div>
            </li>
            <li className={`nav-item ${activeTab === TOOLTIP_TEMPLATE && 'active'}`}>
              <div
                className="nav-link"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  toggle(TOOLTIP_TEMPLATE);
                }}
              >
                <i className={`wb ${drapcodeIcon(TOOLTIP_TEMPLATE)}`} size={'md'}></i>&nbsp; Tooltip
                Templates
              </div>
            </li>
            <li className={`nav-item ${activeTab === AGREEMENT_TEMPLATE && 'active'}`}>
              <div
                className="nav-link"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  toggle(AGREEMENT_TEMPLATE);
                }}
              >
                <i className={`wb ${drapcodeIcon(AGREEMENT_TEMPLATE)}`} size={'md'}></i>&nbsp;
                Agreement Templates
              </div>
            </li>
            {installedPlugins &&
              installedPlugins.some((plugin) => plugin.code === pluginCode.TYPESENSE_SEARCH) && (
                <li
                  className={`nav-item ${activeTab === TYPESENSE_SEARCH_TEMPLATE ? 'active' : ''}`}
                >
                  <div
                    className="nav-link"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      toggle(TYPESENSE_SEARCH_TEMPLATE);
                    }}
                  >
                    <i className={`wb ${drapcodeIcon(TYPESENSE_SEARCH_TEMPLATE)}`} size={'md'}></i>
                    &nbsp; Typesense Search Template
                  </div>
                </li>
              )}
            {installedPlugins &&
              installedPlugins.some((plugin) => plugin.code === pluginCode.SOCKET_IO) && (
                <li className={`nav-item ${activeTab === SOCKET_IO_TEMPLATE && 'active'}`}>
                  <div
                    className="nav-link"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      toggle(SOCKET_IO_TEMPLATE);
                    }}
                  >
                    <i className={`wb ${drapcodeIcon(SOCKET_IO_TEMPLATE)}`} size={'md'}></i>
                    &nbsp; Socket IO Templates
                  </div>
                </li>
              )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
